module.exports = __webpack_public_path__ + "img/play_white.78736a83.svg";